export default __webpack_public_path__ + "static/media/close.3b7f3f8f.svg";